<template>
  <div class="pop-box">
    <!-- 底部立即体验弹出 -->
    <van-popup
      id="practicePopup"
      v-model="practiceMenuShow"
      clearable
      closeable
      round
      position="bottom"
      @close="handleClosePop"
    >
      <div class="formData">
        <iframe 
          id="experienceForm" 
          width="100%" 
          height="500" 
          frameborder="0" 
          src="https://app.swhudong.com/apply/d6a9666c14e14c0a8acc035dfad371bb" 
          style="height: 500px" 
          onload="this.style.height='500px'"
        ></iframe>
      </div>
    </van-popup>
    <!-- 底部立即体验提交后弹出的窗口 -->
    <van-popup
      id="afterPracticePopup"
      v-model="afterPracticeMenuShow"
      closeable
      round
      position="bottom"
      @close="handleAfterClosePop"
    >
      <div class="bg">
        <img src="../../assets/img/phoneHomePage/afterPop.png" />
      </div>
      <div class="context">
        <div class="title">提交成功</div>
        <div class="text">我们会在3个工作日内与您联系，请注意接听来电</div>
        <van-button type="info" @click="handleAfterClosePop">好的</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: "ExperienceNow",
  components: {},
  props: {
    isPopShow: Boolean,
  },
  data() {
    return {
      practiceMenuShow: false, // 立即体验弹窗
      afterPracticeMenuShow: false, // 提交表单后弹窗
    };
  },
  watch: {
    isPopShow() {
      this.practiceMenuShow = this.isPopShow;
    },
  },
  methods: {
    // 关闭立即体验
    handleClosePop() {
      const self = this;
      self.$emit("CloseExperienceNow");
    },
    // 关闭提交表单后的弹出层
    handleAfterClosePop() {
      const self = this;
      self.afterPracticeMenuShow = false;
    },
  },
};
</script>
<style scoped>
#practicePopup .title {
  font-size: 19px;
  text-align: center;
  margin: 23px 13px 5px 13px;
  font-weight: 500;
}
.formData {
  display: flex;
  justify-content: center;
  padding: 15px 10px;
}
.formData > iframe {
  width: 100%;
  border: none;
}
#afterPracticePopup .bg {
  margin: 40px 0 20px 0;
  text-align: center;
}
#afterPracticePopup .bg > img {
  height: 70px;
}
#afterPracticePopup .context {
  text-align: center;
}
#afterPracticePopup .context .title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
}
#afterPracticePopup .context .text {
  font-size: 14px;
  margin-bottom: 30px;
}
#afterPracticePopup .context .van-button {
  width: 90%;
  font-size: 14px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/include/ExperienceNow.vue